export function fillShape(ctx: CanvasRenderingContext2D, fillColor: string) {
  ctx.fillStyle = fillColor;
  ctx.fill();
}
